
import Video from './components/Video/Video';
import Banner from './components/Banner/Banner';
import Biographie from './components/Biographie/Biographie';
import NavPictures from './components/NavPictures/NavPictures';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';







const Home = () => {
  return(
    <>
      <Navbar />
      <Banner /> 
      <Video />
      <Biographie /> 
      <NavPictures />
      <Footer />
     
      
      

    </>
  )
}

export default Home;